module.exports = __webpack_public_path__ + "img/logocendekia2.4fcc35e2.png";